import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AdminDashboard.css';
import Products from '../../hooks/Productcall';
import Category from '../../hooks/categorycall';
import useFetchAllProducts from '../../hooks/allProduct';
import { UsersCall } from '../../hooks/UsersCall';
import AdminTable from './AdminTable';
import Brand from '../../hooks/brandCalls';
import AdminCard from './AdminCard';
import Order from '../../hooks/orderCall';
import { useTheme } from '../assets/context/ThemeContex';

const AdminNav = () => {
  const [data, setData] = useState(null); // Holds fetched data
  const [selectedItem, setSelectedItem] = useState('Home'); // Tracks selected item

  // Hook instances for fetching data
  const orderHook = Order();
  const productHook = useFetchAllProducts();
  const categoryHook = Category();
  const userHook = UsersCall();
  const brandHook = Brand();

  const { toggleTheme, theme: themeObj } = useTheme();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (selectedItem === "Product") {
          response = productHook.productData.map((item) => ({
            id: item.id,
            Name: item.name,
            price: item.price,
            category: item.category,
          }));
        } else if (selectedItem === "Category") {
          response = categoryHook.categoryData.map((item) => ({
            id: item.id,
            Name: item.name,
          }));
        } else if (selectedItem === "User") {
          response = userHook.userData.map((user) => ({
            id: user.id,
            Name: user.displayed_name,
            username: user.username,
            email: user.email,
          }));
        }
        else if (selectedItem === "Brand") {
          response = brandHook.brandData.map((brand) => ({
            id: brand.id,
            Name: brand.brand_name
          }));
        }
        else if (selectedItem === "Order") {
          response = orderHook.orderData.map((order) => ({
            id: order.id,
            Name: order.shipping_name,
            order_date: order.order_date,
            Total: order.total_amount,
            Contact: order.shipping_contact,
            Status: order.order_status,
            Invoice: order.invoice_number,
            //shipping_address: order.shipping_address,
            
          }));
        }

        if (response) setData(response);
      } catch (error) {
        //console.error(`Error fetching ${selectedItem} data:`, error);
      }
    };
    fetchData();
  }, [selectedItem]);

  const handleItem = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className="admin-dashboard" style={{ background: 'var(--background, #181818)', color: 'var(--textMain, gold)', minHeight: '100vh', padding: '1.5em 0' }}>
      <nav className="nav flex-column my-3" style={{ background: 'var(--cardBackground, #222)', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '1.5em 1em', margin: '0 1em' }}>
        <button onClick={toggleTheme} style={{marginBottom: '1em', background: 'var(--primary)', color: '#222', border: 'none', borderRadius: '8px', fontWeight: 600, padding: '0.5em 1em', cursor: 'pointer'}}>
          Toggle Theme (Current: {themeObj.name})
        </button>
        <Link onClick={() => handleItem('Home')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Home</Link>
        <Link onClick={() => handleItem('Product')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Products</Link>
        <Link onClick={() => handleItem('Category')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Category</Link>
        <Link onClick={() => handleItem('User')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Users</Link>
        <Link onClick={() => handleItem('Brand')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Brand</Link>
        <Link onClick={() => handleItem('Order')} className="nav-link" style={{ color: 'gold', fontWeight: 600, marginBottom: '0.5em' }}>Orders</Link>
      </nav>
      <div className="admin-content" style={{ background: 'var(--cardBackground, #fffbe6)', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '2em', margin: '1.5em 1em' }}>
        {selectedItem === 'Home' ? (
          <>
            <h2 style={{ color: 'var(--textHeading, #00C135)' }}>Welcome to the Admin Dashboard</h2>
            <div>
              <p style={{ color: 'var(--textMain, #222)' }}>Here you can manage your products, categories, users, and brands.</p>
              <AdminCard title="Total Products" value={productHook.productData?.length || 0} />
              <AdminCard title="Total Users" value={userHook.userData?.length || 0} />
              <AdminCard title="Total Cateegory" value={categoryHook.categoryData?.length || 0} />
              <AdminCard title="Total Brand" value={brandHook.brandData?.length || 0} />
              <AdminCard title="Total Orders" value={orderHook.orderData?.length || 0} />
            </div>
          </>
        ) : (
          <AdminTable items={data} type={selectedItem} />
        )}
      </div>
    </div>
  );
};

export default AdminNav;
